namespace appn.views.billing.payments {
    class InitArgs {
        paymentConfigIsValid: boolean = false;
        gateway: string = 'PinPayments';
        gatewayKey: string = appn.emptyString;
        gatewayEnv: string = appn.emptyString;
        entityId: string = appn.emptyString;
        outstandingInvoices: boolean = false;
        paymentsURL: string = appn.emptyString;
        inProgressInvoiceId: string = appn.emptyString;
        countryStates: Record<string, Record<string, string>> = {};
    }

    let _initArgs: InitArgs;

    let _$form: JQuery<HTMLElement>,
        _$submitButton: JQuery<HTMLElement>;

    let dataTable: any = null;
    let _stripe: any = null;
    let _stripeElements: any = null;
    let _pinHostedFields: any = null;
    
    export function gateway(): string { return _initArgs.gateway; }

    export function init(args: InitArgs): void {
        _initArgs = args;

        createDatatable();

        appn.ui.initCountryStateDropdown({
            countrySelector: '#address-country',
            stateTextSelector: '#address-state',
            stateSelectSelector: '#address-state-select',
            countryStates: args.countryStates
        });

        initAndToggleForInputOrDisplay(_initArgs.paymentConfigIsValid);
        addEvents();
    }

    function initHostedFields() {
        // Dynamically extract styles from a real input on the page to ensure iframes match the theme perfectly.
        const themeSource = document.getElementById('address-line1') as HTMLElement;
        const baseStyles = window.getComputedStyle(themeSource);
        const placeholderStyles = window.getComputedStyle(themeSource, '::placeholder');

        const theme = {
            color: baseStyles.color,
            fontFamily: baseStyles.fontFamily,
            fontSize: baseStyles.fontSize,
            placeholderColor: placeholderStyles.color || '#939ba2' // Fallback to Appenate theme default (lighten($gray-600, 15%))
        };

        if (_initArgs.gateway === 'Stripe') {
            _stripe = (window as any).Stripe(_initArgs.gatewayKey);
            const elements = _stripe.elements();

            const stripeStyle = {
                base: {
                    color: theme.color,
                    fontFamily: theme.fontFamily,
                    fontSize: theme.fontSize,
                    '::placeholder': {
                        color: theme.placeholderColor
                    }
                },
                invalid: {
                    color: '#dc3545'
                }
            };

            _stripeElements = {};
            _stripeElements.cardNumber = elements.create('cardNumber', { style: stripeStyle });
            _stripeElements.cardNumber.mount('#cc-number-mount');

            _stripeElements.cardExpiry = elements.create('cardExpiry', { style: stripeStyle });
            _stripeElements.cardExpiry.mount('#cc-expiry-mount');

            _stripeElements.cardCvc = elements.create('cardCvc', { style: stripeStyle });
            _stripeElements.cardCvc.mount('#cc-cvc-mount');

            // Add change listeners for validation styling
            Object.keys(_stripeElements).forEach(key => {
                _stripeElements[key].on('change', function(event: any) {
                    const displayError = document.getElementById(key + '-errors');
                    const $container = $(_stripeElements[key]._id || '#' + key + '-mount');
                    if (event.error) {
                        $container.addClass('has-error').removeClass('has-success');
                    } else {
                        $container.removeClass('has-error').addClass('has-success');
                    }
                });
            });
        }
        else {
            // Pin Payments Hosted Fields v1
            // Requires exactly: name, number, cvc, expiry
            _pinHostedFields = (window as any).HostedFields.create({
                sandbox: _initArgs.gatewayEnv !== 'live',
                autocomplete: true,
                styles: {
                    'input': {
                        'font-size': theme.fontSize,
                        'font-family': theme.fontFamily,
                        'color': theme.color
                    },
                    'input::placeholder': {
                        'color': theme.placeholderColor
                    },
                    '.hosted-fields-invalid:not(:focus)': {
                        'color': '#dc3545'
                    }
                },
                fields: {
                    name: {
                        selector: '#cc-name-mount',
                        placeholder: T('Card Holder Name')
                    },
                    number: {
                        selector: '#cc-number-mount',
                        placeholder: '1234 5678 9012 3456'
                    },
                    cvc: {
                        selector: '#cc-cvc-mount',
                        placeholder: '123'
                    },
                    expiry: {
                        selector: '#cc-expiry-mount',
                        placeholder: 'MM/YY'
                    }
                }
            });

            // Add validity listeners for Pin Hosted Fields validation styling
            _pinHostedFields.on('validityChange', function(event: any) {
                const $container = $(event.selector);
                if (event.valid) {
                    $container.removeClass('has-error').addClass('has-success');
                } else {
                    $container.addClass('has-error').removeClass('has-success');
                }
            });
        }
    }

    function initAndToggleForInputOrDisplay(isDisplay: boolean) {
        $('#Save, .setcc, .cancelupdatecc').toggleClass('hide', isDisplay);
        $('.showcc, .updatecc').toggleClass('hide', !isDisplay);

        if (isDisplay) 
            return;

        if (!_stripeElements && !_pinHostedFields) 
            initHostedFields();

        $('#cc-name').toggleClass('hide', !_stripeElements);
        $('#cc-name-mount').toggleClass('hide', !!_stripeElements);
    }

    function addEvents() {
        $('.updatecc').click(function(e) {
            e.preventDefault();
            initAndToggleForInputOrDisplay(false);
        });

        $('.cancelupdatecc').click(function(e) {
            e.preventDefault();
            initAndToggleForInputOrDisplay(true);
        });

        // As we use name-less (no name attr) fields, jquery validation is basically broken.
        // We also can't use jquery unobtrusive validation as a result (since jq.unob depends on jq.validate).
        // However we absolutely MUST keep specific inputs out of form for security purposes (never post cc info to our servers),
        // thus we hook a single general purpose validator method which will be fired on all fields,
        // due to the lack of name attributes for jquery.validate() to hook to.
        // We also MUST explicitly avoid using Razor HtmlHelper * For() methods to create inputs, since those
        // methods add data-val attributes, which causes unob validation to trigger, breaking our custom stuff here.
        ($.validator as any).ignoreUnobtrusive = true;

        _$form = $('form#appnForm');

        // manually invoke jq.validate since jq.unob is broken due to name-less fields
        _$form.validate({
            errorPlacement: function(error, element) {
                // don't inject error label
            },
            highlight: function(element) {
                const $ctlgrp = $(element).closest('.control-group');
                $ctlgrp.removeClass('has-success').addClass('has-error');
            },
            success: function($element) {
                let ctl = ($element[0] as any).control;
                if (ctl === null)
                    ctl = $('#' + ($element[0] as any).htmlFor);
                const $ctlgrp = $(ctl).closest('.control-group').first();
                $ctlgrp.removeClass('has-error').addClass('has-success');
            }
        });

        // Required rule works ok despite lack of name attributes.
        $('#address-line1').rules('add', { required: true });
        $('#address-city').rules('add', { required: true });
        $('#address-state').rules('add', { required: true });
        $('#address-postcode').rules('add', { required: true });
        $('#address-country').rules('add', { required: true });

        // Stripe Name field validation (Pin uses hosted name so cc-name is hidden/unused)
        if (_initArgs.gateway === 'Stripe')
            $('#cc-name').rules('add', { required: true });

        _$submitButton = _$form.find(':submit');

        _$form.submit(function(e) {
            e.preventDefault();
            
            if (!_$form.valid()) {
                _$submitButton.removeAttr('disabled');
                return;
            }

            // Disable the submit button to prevent multiple clicks
            _$submitButton.attr({ disabled: true });

            // Handle payment of invoice(s) with existing card loaded
            if ($('#Pay').length > 0 && $('.showcc:visible').length > 0) {
                appn.dialog.showLoading(T('Processing Payment'));
                (_$form.get(0) as HTMLFormElement).submit();
                return;
            }

            // We are running a new card load/update
            appn.dialog.showLoading(T('Processing...please wait.'));

            // Clear previous errors
            if (_initArgs.gateway === 'Stripe') {
                _stripe.createPaymentMethod({
                    type: 'card',
                    card: _stripeElements.cardNumber,
                    billing_details: {
                        name: $('#cc-name').val() as string,
                        address: {
                            line1: $('#address-line1').val() as string,
                            line2: $('#address-line2').val() as string,
                            city: $('#address-city').val() as string,
                            state: $('#address-state').val() as string,
                            postal_code: $('#address-postcode').val() as string,
                            country: $('#address-country').val() as string
                        }
                    }
                }).then(function(result: any) {
                    if (result.error) {
                        let message = result.error.error_description || result.error.message;
                        handleError(message, result.error.messages);
                    }
                    else 
                        onCardCreateSuccess(result.paymentMethod);
                });
            }
            else {
                // Request a token from Pin Payments Hosted Fields
                _pinHostedFields.tokenize({
                        publishable_api_key: _initArgs.gatewayKey,
                        address_line1: $('#address-line1').val() as string,
                        address_line2: $('#address-line2').val() as string,
                        address_city: $('#address-city').val() as string,
                        address_postcode: $('#address-postcode').val() as string,
                        address_state: $('#address-state').val() as string,
                        address_country: $('#address-country').val() as string
                    },
                    function(err: any, response: any) {
                        if (err) {
                            let message = err.error_description || err.message;
                            handleError(message, err.messages);
                        }
                        else 
                            onCardCreateSuccess(response);
                    }
                );
            }
        });

        $(document).on('click', '.btn-resetFilters', function (e: Event) {
            dataTable.clearSearch();
        });
    }

    function onCardCreateSuccess(response: any) {
        if (_initArgs.outstandingInvoices || _initArgs.inProgressInvoiceId)
            appn.dialog.showLoading(T('Processing Payment'));
        else
            appn.dialog.showLoading(T('Validating Card'));

        // Submit the new card token to server for customer creation and invoice charging
        appn.ajax.post({
            url: _initArgs.paymentsURL,
            data: { 
                cardToken: response.id || response.token,
                inProgressInvoiceId: _initArgs.inProgressInvoiceId,
                entityId: _initArgs.entityId
            },
            done: function(result: IPaymentsResult) {
                if (result.success)
                    window.location.href = result.navToURL;
                else if (result.cardAuthReq)
                    performCardAuth(result);
                else
                    handleError(result.message);
            },
            fail: function(jqXHR: any, textStatus: any, errorThrown: any) {
                handleError(errorThrown);
            }
        });
    }

    async function performCardAuth(payment: IPaymentsResult) {
        if (_stripe) {
            const { error, paymentIntent } = await _stripe.confirmCardPayment(payment.cardAuthToken);
            if (error)
                handleError(error.message);
            else
                window.location.href = payment.navToURL;
        }
        else {
            // Pin doesn't have fancy modal-based auth stuff, so redirect whole page
            window.location.href = payment.cardAuthURL;
        }
    }

    function handleError(message: string, messages?: any) {
        if (messages)
            $.each(messages, function(index, paramError) {
                message += `<br>${paramError.message}`;
            });
        
        appn.toast.notify(toast.Type.error, message);

        appn.dialog.hideLoading();

        // Re-enable the submit button
        _$submitButton.removeAttr('disabled');
        appn.hasFormSubmitAlreadyHappened = false;
    }

    function createDatatable() {
        dataTable = appn.dataTable.create('.chargesTable', {
            scrollY: '40vh',
            iDisplayLength: 25,
            oLanguage: {
                sInfoEmpty: T('No charges processed yet')
            },
            bProcessing: true,
            aaSorting: [[0, 'desc']],
            bServerSide: true,
            sAjaxSource: 'ChargesDataTable',
            fnServerData: function(data: any) {
                data.push({ name: 'sCustom_0', value: _initArgs.entityId }); 
            },
            aoColumns: [
                { bSortable: false, sWidth: '15%' },
                { bSortable: false, sWidth: '25%' },
                { bSortable: false, sWidth: '15%' },
                { bSortable: false, sWidth: '20%' },
                { bSortable: false, sWidth: '25%' }
            ],
            fnInitComplete: function () {
                appn.dataTable.addSearchPlaceholder(T('Filter results where the Payments <b>Date/Time, Description or Result</b> contains a keyword typed in here'));

                appn.saveMeState.init(function () {
                    dataTable.fnDraw(false);
                },
                    function () {
                        dataTable.fnDraw(false);

                    }, '.dataTables_filter');
            }
        });
    }

    interface IPaymentsResult extends IMethodResult {
        cardAuthReq: boolean;
        cardAuthURL: string;
        cardAuthToken: string;
        navToURL: string;
    }
}
